// extracted by mini-css-extract-plugin
export var active = "_20-b";
export var activeIndicator = "_20-6";
export var animate = "_20-a";
export var disabled = "_20-c";
export var flat = "_20-1";
export var fullWidth = "_20-3";
export var lg = "_20-9";
export var md = "_20-8";
export var redoButtonTabGroup = "_20-0";
export var sm = "_20-7";
export var tabButton = "_20-4";
export var tabButtonsContainer = "_20-2";
export var xs = "_20-5";